/*jslint browser */
/*global process */

import Cart from "../model/cart/cart";
import Price from "../utils/price";

var $ = jQuery;

/**
 *
 */
export default class AccessoriesController
{
    private _selectAccessory: JQuery;
    private _priceContainer: JQuery;
    private _variationId: JQuery;
    private _settings: any;
    private _cart: Cart;
    private _qty: JQuery;
    private _accessoryQuantity: JQuery;
    private _xtQuantity: JQuery;
    private _singleAddToCartButton: JQuery;
    private _xtSingleAddToCartButton: JQuery;
    private _addToStorage: JQuery;
    private _productAdditionalPrice : JQuery;

    /**
     *
     */
    constructor(settings: any)
    {
        this._settings = settings;
        this._cart = new Cart();
    }

    public accesoriesAction(): void
    {
        this._cart.init();
        if(this._settings.productPrice.price) {
            this._cart.setProductPrice(this._settings.productPrice.price);
        }
        this._cart.setMainProductId(this._settings.productId);
        this.registerEvents();
        this.refreshPrice();
        this.checkAddToCartStateAndDisableEnableButton();
    }

    /**
     *
     * @private
     */
    private registerEvents(): void
    {
        this._selectAccessory = $('.select-accessory');
        this._priceContainer = $('.price-container');
        this._qty = $('.qty');
        this._accessoryQuantity = $('.accessory-quantity');
        this._xtQuantity = $('.xt-quantity');
        this._singleAddToCartButton = $('.single_add_to_cart_button');
        this._xtSingleAddToCartButton = $('.xt-single_add_to_cart_button');
        this._productAdditionalPrice = $('#product_additional_price');

        this._addToStorage = $('.add-to-storage');
        if(this._cart.isProductVariation()) {
            this._variationId = $('.variation_id');

            this._variationId.on('change', (e) => {
                this.variationChanged();
            })
        }

        this._selectAccessory.on('click', (e) => {
            this.selectAccessoryClick();
        })

        this._qty.on('change', (e) => {
            this.qtyChange();
        })

        this._xtQuantity.on('change', (e) => {
            this.xtQuantityChange();
        })

        this._xtSingleAddToCartButton.on('click', (e) => {
            this.xtSingleAddToCartButtonClick();
        })

        this._productAdditionalPrice.on('change', (e) => {
            this.productAdditionalPriceChange();
        })
    }

    private variationChanged(): void {
        this.refreshPrice();
        this.checkAddToCartStateAndDisableEnableButton();
        this._addToStorage.attr('data-variation', this._variationId.val() as number);
        this._addToStorage.attr('data-price', this._cart.getCurrentProductPrice());
        this._addToStorage.attr('data-image', $('.flex-active-slide').attr('data-thumb'));
    }

    private selectAccessoryClick(): void {
        this.refreshPrice();
    }

    private qtyChange(): void {
        //this.updateAccessoryQuantityView();
        //this.refreshPrice();
    }

    private xtQuantityChange() {
        this._qty.val(this._xtQuantity.val());
        this.updateAccessoryQuantityView();
        this.refreshPrice();
        this._addToStorage.attr('data-quantity', this._xtQuantity.val() as number);
    }

    private xtSingleAddToCartButtonClick() {
        this._singleAddToCartButton.trigger('click');
    }

    private productAdditionalPriceChange() {
        this.refreshPrice();
    }

    private refreshPrice(): void {
        this.updateCartData();
        this.updatePriceView();
        if(this._cart.getPrice() == 0) {
            this._addToStorage.attr('data-sum-price', this._addToStorage.attr('data-price'));
        } else {
            this._addToStorage.attr('data-sum-price', this._cart.getPrice());
        }
    }

    private updateCartData(): void {
        this._cart.update();
    }

    private updatePriceView(): void {
        const price = new Price(this._settings.priceFormat.local, this._settings.priceFormat.currency);
        if(this._cart.getPrice() > 0) {
            this._priceContainer.html(price.getFormated(this._cart.getPrice()));
        }
    }

    private updateAccessoryQuantityView(): void {
        this._accessoryQuantity.html(this._qty.val());
    }

    private checkAddToCartStateAndDisableEnableButton(): void {
        setTimeout(() => {
            if(this.isWpButtonEnabled()) {
                this._xtSingleAddToCartButton.removeClass('disabled');
            } else {
                this._xtSingleAddToCartButton.addClass('disabled');
            }
        }, 500);
    }

    private isWpButtonEnabled(): boolean {
        if(!this._singleAddToCartButton.hasClass('disabled')) {
            return true;
        } else {
            return false;
        }
    }
}